<template>
  <div id="app" v-if="isReady">

    <div class="update-name-wrap" v-if="showUpdateName">
      <div class="guide-shadow"></div>
      <div class="guide-content">
        <p>系统检测到账号风险</p>
        <p>为了保护您的账户安全，请在完成总部管理员用户名修改后继续使用系统</p>
        <div class="start-modify" @click="modifyName">开始修改</div>
      </div>

    </div>
    <comp-login-guide :userInfo="userInfo" v-else-if="showLoginGuide"/>
    <template v-else>
      <!-- 组织结构引导图，只出现一次 -->
      <img class="img-guide" :src="OrgGuideImg" v-if="isImgShow" @click="hideOrgImg()"/>
      <!--<Guide v-if="showReportGuide" :userInfo="userInfo"></Guide>-->
      <div v-else>
        <NavBar v-if="!isCRMUser"/>
        <navbar-e :userInfo="userInfo" type="HQ" activeMenu="chain" v-else/>
        <div class="body-content">
          <SideNav v-if="!isCRMUser"/>
          <SideNavCRM v-else :menus="menus"/>
          <comp-bread-crumb :items="breadCrumbs"></comp-bread-crumb>
          <div class="content-wrapper">
            <MessageNav/>
            <div class="app-content">
              <div class="content-inner-wrapper">
                <keep-alive :include="componentName">
                  <router-view></router-view>
                </keep-alive>
              </div>
            </div>
          </div>
        </div>
      </div>
      <comp-protocol :protocol="protocol"></comp-protocol>

    </template>
  <UpdateName ref="updateNameDialog" ></UpdateName>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {mapActions, mapState} from 'vuex';

  import NavBar from './components/ui/NavBar/NavBar.vue';
  import SideNav from './components/ui/SideNav/SideNav.vue';
  import SideNavCRM from './components/ui/SideNav/SideNavCRM.vue';
  import MessageNav from './components/ui/MessageNav/MessageNav.vue';
  import Guide from './components/ui/Guide/Guide.vue';
  import UpdateName from './components/ui/UpdateName/UpdateName.vue';
  import isCRMUser from '@util/isCRMUser';
  import crmMenus from '@constants/menu-crm';
  import getRouterConf from '@util/getRouterConf';
  import OrgGuideImg from './assets/images/org-guide.png';
  import { lxCidTracker } from '@util/lxTracker';
  import {setGrayCookies} from '@util/setGrayCookies';
  import {setGrayItem, checkGrayItem, removeGrayItem} from '@util/handleGrayByLocalstorage';
  import {getCookie} from '@util/cookie';

  import cookie from 'js-cookie';

  const originalCookie = getCookie("SSID");

  export default {
    components: {
      NavBar,
      SideNav,
      SideNavCRM,
      MessageNav,
      Guide,
      UpdateName
    },
    created () {
      if (checkGrayItem('pingxin_fe_irs-static_crm_update_close')) {
        this.queryCrmUpdateClose();
      }
      this.$axios.all([
        this.getOrgTree(),
        this.getUserAndHotelInfo(),
        this.checkHqPos(),
        this.getMenuList(),
        window.getComp('hqStatic')
      ]).then(this.$axios.spread((orgTree, userAndHotelInfo, isHqPos, menu) => {
        this.getAllGray();
        window.registerComponent(Vue);
        setGrayCookies(this.userInfo.agencyId);
        this.$agency.isHQ = true;
        if (cookie.get('OLDLOGINFROMHQ')) {  // 从老域名登陆
          this.getGrey(this.userInfo).then(greyInfo => {
            //小流量用户，显示登陆引导页
            if (greyInfo && greyInfo.code === 200 && greyInfo.strategy) {

              lxCidTracker({meta: {cid: 'c_eco_qzbcad7g'}});
              this.showLoginGuide = true;
            }
          });
        }
        this.getReportGray('pingxin_fe_report-web_1_8');
        this.$axios.all([
          this.queryRepeatName(),
          this.getNameGray(this.userInfo)
        ]).then(this.$axios.spread((nameRepeat, nameGray) => {
          if (nameGray.code === 200 && nameGray.strategy && nameRepeat.code === 200 && nameRepeat.data) {
            lxCidTracker({ meta: { cid: 'c_eco_gqa4onyd'}});
            this.showUpdateName = true;
          }
        }));


        this.menus = ((isHqPos && isHqPos.containCount !== 0 && this.isCRMUser) || (this.userInfo && this.userInfo.nativeForAndroid === true))
          ? crmMenus.filter((item) => {
            return ['60', '110', '130', '140'].indexOf(item.id) === -1;
          }) : crmMenus;
        this.isReady = true;
        if (this.userInfo.firstLogin === 1 || localStorage.getItem('crmFirstLogin')) {
          this.isImgShow = true;
          localStorage.removeItem('crmFirstLogin');
        }
        if (this.isCRMUser) {
          const orgLength = orgTree.data.filter((item) => {
            return item.type === 3;
          }).length;
          localStorage.setItem('orgLength', orgLength);
          localStorage.setItem('isAndroid', this.userInfo && this.userInfo.nativeForAndroid);
          if (isHqPos === null) {
            localStorage.setItem('isHqPos', 0);
          } else if (isHqPos.containCount === 0) {
            localStorage.setItem('isHqPos', 0);
          } else if (isHqPos.containCount === orgLength) {
            localStorage.setItem('isHqPos', 2);
          } else {
            localStorage.setItem('isHqPos', 1);
          }
          let hasShowReportGuideIds = cookie.get('hasShowReportGuideIds');
          if (hasShowReportGuideIds) {
            hasShowReportGuideIds = JSON.parse(hasShowReportGuideIds);
          } else {
            hasShowReportGuideIds = [];
          }
          this.showReportGuide = hasShowReportGuideIds.indexOf(this.userInfo.userId) === -1
            && isHqPos !== null && isHqPos.containCount !== 0 && (menu && menu.menuList && menu.menuList.report);
        }
        this.navigateTo({
          path: location.hash.substring(1)
        });
        // 首次或刷新进入页面时router.afterEach无法获取到store里面的值，需在此进行页面埋点
        lxCidTracker(this.$route);
        // 判断是否签署过最新协议
        if ((userAndHotelInfo.data.type === 1 || userAndHotelInfo.data.type === 6) && userAndHotelInfo.data.userType === 0) {
          this.$axios.get('/hq-agency/agreement/agency/valid').then((res) => {
            if (res.code === 200) {
              if (!res.data) {
                this.protocol.visible = true;
                lxCidTracker({ meta: { cid: 'c_eco_59t52oko'}});
                LXAnalytics && LXAnalytics('moduleView', 'b_eco_fjbfbmxi_mv'); //协议变更模块曝光
              }
            } else {
              this.$message.error("网络异常，请稍后再试");
            }
          });
        }
        // 判断CRM切流
        this.getCRMSplit(this.userInfo).then((res) => {
          if (res.code === 200) {
            if (res.data === true) {
              cookie.set('crm-3', 'Y', {expires: 3650});
            } else {
              cookie.remove('crm-3');
            }
          }
        });
        // CRM换名灰度添加（全量默认全部都是cookie 等其他项目不再使用，去掉这行代码）
        cookie.set('fe-crm-name', 'Y', {expires: 3650});
        cookie.remove('fe-repeat-click', 'Y', {expires: 3650});
        this.getRepeatGray(this.userInfo).then((res) => {
          if (res.code === 200 && res.strategy) {
            setGrayItem('new-repeat-click');
          } else {
            removeGrayItem('new-repeat-click');
          }
        });
      }));
    },
    mounted (){
      if (window.addEventListener) {
        window.addEventListener('storage', this.verifyCookie);
      } else if (window.attachEvent) {
        window.attachEvent('storage', this.verifyCookie);
      }
    },
    destroyed (){
      if (window.removeEventListener) {
        window.removeEventListener('storage', this.verifyCookie);
      } else if (window.detachEvent) {
        window.detachEvent('storage', this.verifyCookie);
      }
    },
    computed: {
      ...mapState(['userInfo'])
    },
    data () {
      return {
        componentName: ['PayMethod','MenuManage', 'geto-duty'],
        isReady: false,
        isCRMUser: isCRMUser(),
        isShowSys: true,
        menus: [],
        OrgGuideImg,
        isImgShow: false,
        breadCrumbs: [{
          name: '首页'
        }],
        showReportGuide: false,
        showLoginGuide: false,
        protocol: {
          visible: false
        },
        showUpdateName: false
      };
    },
    methods: {
      ...mapActions(['getOrgTree', 'getUserAndHotelInfo', 'queryCrmUpdateClose']),
      getAllGray () {
        const grayList = [
          'pingxin_fe_hq-static_feature',
          'pingxin_fe_hq-static_hotfix',
          'pingxin_fe_hq-static_food-publish',
          'pingxin_fe_irs-static_crm_update_close',
          'pingxin_diancan_bsj_audit_to_c',
        ];
        const testKeys = grayList.join(',');
        const url = `/erpabtest-api-v2/batch/getTreatmentFe?agencyid=${this.userInfo.agencyId}&testKeys=${testKeys}`;
        this.$axios.get(url).then(res => {
          if (res && res.code === 200) {
            grayList.forEach((grayKey) => {
              if (res[grayKey] && res[grayKey].strategy) {
                //如果返回结果中这个key有值，则设置为Y
                setGrayItem(grayKey, 'Y');
              } else {
                //如果返回结果中这个key没有值，为了缩量，需要删除该key
                removeGrayItem(grayKey);
              }
            });
          }
        });
      },
      getGrey (userInfo) {
        if (!userInfo) {
          return;
        }
        return this.$axios.get(`/erpabtest-api/getTreatmentFe?agencyid=${userInfo.agencyId}&testKey=pingxin_fe_loginRedirect`);
      },
      // CRM灰度
      getRepeatGray (userInfo) {
        if (!userInfo) {
          return;
        }
        return this.$axios.get(`/erpabtest-api/getTreatmentFe?agencyid=${userInfo.agencyId}&testKey=pingxin_fe_repeatClick`);

      },
      // 用户名去重灰度
      getNameGray (userInfo) {
        if (!userInfo) {
          return;
        }
        return this.$axios.get(`/erpabtest-api/getTreatmentFe?agencyid=${userInfo.agencyId}&testKey=pingxin_agency_repeat_username_key`);

      },
      queryRepeatName () {
        return this.$axios.get('/metis-user-web/user/whiteUser');
      },
      // 判断CRM是否已经切流（异步接口，不影响主干流程）
      getCRMSplit (userInfo) {
        if (!userInfo) {
          return;
        }
        return this.$axios.get(`/crm-api/eos-api-web/split/check-split?agencyId=${userInfo.agencyId}`);
      },
      // v1.8报表中心
      getReportGray (testKey, strategy = 'Y') {
        if (!this.userInfo) {
          return;
        }
        const params = {
          agencyid: this.userInfo.agencyId,
          testKeys: testKey
        };
        return this.$axios.get(`/erpabtest-api-v2/batch/getTreatmentFe`, {params}).then(res => {
          if (res.code === 200 && res[testKey] && res[testKey]['strategy']) {
            setGrayItem(testKey, strategy);
          } else {
            removeGrayItem(testKey);
          }
        });
      },
      getTitle () {
        const {title} = this.$route.meta;
        if (title && typeof title === 'string') {
          return [{name: title}];
        } else if (title && typeof title === 'object') {
          return title;
        } else {
          if (this.$route.path === '/Midware' || this.$route.path === '/') {
            return;
          }
          return [{name: getRouterConf(this.$route.path)[1].name}];
        }
      },
      getMenuList () {
        if (!this.isCRMUser) {
          return Promise.resolve();
        }
        if (!localStorage.getItem('menuList')) {
          return this.$axios.get('/hq-agency/user/menu').then((menu) => {
            if (menu.code === 200) {
              let menuList = {};
              menu.data.forEach(item => {
                menuList[item.systemCode] = item.menu.map((one) => {
                  return one.id;
                });
              });
              localStorage.setItem('menu', JSON.stringify(menu.data));
              localStorage.setItem('menuList', JSON.stringify(menuList));
              return Promise.resolve({
                menu: menu.data,
                menuList
              });
            }
          });
        } else {
          return Promise.resolve({
            menu: JSON.parse(localStorage.getItem('menu')),
            menuList: JSON.parse(localStorage.getItem('menuList'))
          });
        }
      },
      // 点击引导图，引导图消失
      hideOrgImg () {
        this.isImgShow = false;
      },
      checkHqPos () {
        const queryParams = {
          queryLists: JSON.stringify([
            [{
              operation: 5,
              version: '2.30.5'
            }],
            [{
              operation: 3,
              version: '2.33'
            }]
          ])
        };
        return this.$axios.post('/hq-agency/agency/check_pos_version', this.$qs.stringify(queryParams)).then((res) => {
          if (res.code === 200) {
            return res.data;
          } else {
            return null;
          }
        });
      },
      modifyName () {
        console.log('modifyName', this.$refs);
        this.$refs.updateNameDialog.show();
      },
      // 校验cookie中SSID是否变化 变化则回到登录页面
      verifyCookie () {
        if (getCookie("SSID") !== originalCookie) {
          window.location.href = "/account-web/account.html";
        }
      },
    },
    watch: {
      '$route': function () {
        this.breadCrumbs = this.getTitle();
      }
    },
  };
</script>

<style lang="less">
  body {
    margin: 0 auto;
    overflow-x: hidden;
  }

  .img-guide {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999999999;
  }

  .body-content {
    position: absolute;
    top: 60px;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .update-name-wrap {
    .guide-shadow {
      position: fixed;
      z-index: 999;
      width: 100%;
      height: 100%;
      opacity: 0.75;
      background: #070707;
    }
    .guide-content {
      position: absolute;
      top: 30%;
      width: 100%;
      text-align: center;
      color: #fff;
      z-index: 1000;
      font-size: 18px;
    }
    .start-modify {
      margin: 30px auto 0;
      width: 166px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      border: 1px solid #fff;
      border-radius: 5px;
      cursor: pointer;
    }
  }


  .content-wrapper {
    position: absolute;
    background: #ececec !important;
    top: 0;
    left: 200px;
    right: 0;
    bottom: 0;
    border-left: 1px solid #DCDCDC;
    overflow-x: auto;
    margin-top: 40px; // 面包屑固定定位，内容区空出40px的上边距
    .app-content {
      width: 100%;
      min-width: 1080px;
      z-index: 1;
      .content-inner-wrapper {
        margin: 10px;
      }
    }
  }

  .comp-breadcrumb {
    position: absolute;
    top: 0;
    right: 0;
    left: 200px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, .2);
    z-index: 1;
  }

  /*侧边栏收起*/
  @media screen and (max-width: 1280px) {
    @navWidth: 60px;
    .sidenav {
      width: @navWidth;
      overflow: visible;
      .menu-name {
        display: none;
      }
      .el-submenu__icon-arrow {
        display: none;
      }
    }

    .el-breadcrumb {
      left: 65px;
    }

    .content-wrapper {
      left: @navWidth + 5;
      .app-content {
        min-width: 1080px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// App.vue?e6f68f46